import { LocationData } from "../types";

export default function hasValidLocation({ city, state, zip }: LocationData) {
    const foundLocation = [city, state, zip].filter(Boolean);
    return Boolean(foundLocation.length === 3)
  }